import { IconAiToolClaude, IconAiToolGemini, IconAiToolGithubCopilot, IconAiToolGrok, IconAiToolMidjourney, IconAiToolOpenai, IconAiToolReplit, IconAiToolWindsurf } from "@/lib/images";
import { StaticImageData } from "next/image";

interface IAiTool {
    name: string;
    icon: StaticImageData;
    alt: string;
}

export const AI_Tools_Marquee_Data = {
    title: "Powered by Leading AI Tools",
    subtitle: "We leverage the best AI tools to deliver exceptional results",
    tools: [
        {
            name: "Claude",
            icon: IconAiToolClaude,
            alt: "Claude AI"
        },
        {
            name: "Gemini",
            icon: IconAiToolGemini,
            alt: "Gemini AI"
        },
        {
            name: "GitHub Copilot",
            icon: IconAiToolGithubCopilot,
            alt: "GitHub Copilot"
        },
        {
            name: "Grok",
            icon: IconAiToolGrok,
            alt: "Grok AI"
        },
        {
            name: "Midjourney",
            icon: IconAiToolMidjourney,
            alt: "Midjourney"
        },
        {
            name: "OpenAI",
            icon: IconAiToolOpenai,
            alt: "OpenAI"
        },
        {
            name: "Replit",
            icon: IconAiToolReplit,
            alt: "Replit"
        },
        {
            name: "Windsurf",
            icon: IconAiToolWindsurf,
            alt: "Windsurf"
        }
    ] as IAiTool[]
}; 